


<template>
  <html>
    <head>
      
    </head>
    <body>
      <navbar></navbar>
       <img
        id="header-s"
        src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png"
      />
      
      <div class="title-page-l">
        <h1>ประวัติการเเลกสินค้า</h1>
      </div>
      <div class="contro">
      <div class="top">
        <nav class="navbar navbar-light bg-light">
          <form class="container-fluid justify-content-start">
            <div class="btPro">
              <button class="btn btn-outline-success me-2" type="button">
                การเเลกคะเเนน
              </button>
            </div>
            <div class="btDo">
              <button
                class="btn btn-sm btn-outline-secondary me-2"
                type="button"
              >
                การสะสมคะเเนน
              </button>
            </div>
            <div class="line-c">
              <hr class="new5" />
            </div>
            <div class="line-d">
              <hr class="new4" />
            </div>
          </form>
        </nav>
      </div>
      <div class="bg-white s">
        <div>
          <img
            class="img-profile"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-img-user.png"
          />
<img class="iconpoint"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-bottom-navigation-01-reward-active.png"
          />
          <span class="name-status">-2000</span>
        
          <br />
          <span class="name-price">พรชนก งามสม</span>
         <br> <span class="name-time">1 เม.ย 2564 | 14.22 น.</span>
      
        </div>
      </div>
   
      </div>
    </body>
  </html>

  
</template>
<script>
import Navbar from "./navbar"
export default {
name:"", 
components:{
    "navbar": Navbar
},
data() {
return {
}
 },
mounted(){
},
}
</script>
<style scoped>
@import "./Css/style.css";
@import url('https://fonts.googleapis.com/css2?family=Prompt:wght@700&display=swap');
.iconpoint{
  height: 30px;
    width: 28px;

    margin-right: 10px;
}
.contro{
margin-top: 70px;
}
hr.new4 {
border: 1px solid #848484;
    width: 180px;
    border-radius: 73px;
    margin-left: -16px;
}
.line-c {
  display: table;
  top: 34px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 1px;
  right: 40px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
}
hr.new5 {
  border: 2.5px solid #ff0000;
  height: 1px;
  width: 197px;
  border-radius: 73px;
  top: 35.1px;
}
.line-d {
  display: table;
  top: 34px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 211px;
  right: 40px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
  float: left;
}
.btPro {
  float: left;

  text-align: center;
}
.btDo {
  float: left;

  text-align: center;
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
}
.btn-outline-success {
  font-family: “Times New Roman”, Times, serif;
  color: #7bc79a;
  border-color: #963c3c00;
  font-weight: bold;
  width: 100%;
  float: right;
  font-size: 19px;
  padding: 10px 10px 10px 32px;
}
.btn-outline-secondary {
  font-family: “Times New Roman”, Times, serif;
  color: #7f8285;
  border-color: #ffffff00;
  font-weight: bold;
  width: 100%;
  float: left;
  font-size: 19px;
}
.navbar {
  color: #ffffff;
}
.bg-dark {
  background-color: #ffffff !important;
  height: 100px;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}

.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 23px;
  color: #ffffff;
  font-family: Prompt SemiBold;
  text-align: center;

}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}
.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  height: 150px;
  width: 340px;
  position: relative;
  overflow: visible;
  top: -2px;
}
.bg-white.s {
     border-radius: 10px;
    height: 122px;
    width: 90%;
    position: relative;
    overflow: visible;
    margin-top: 20px;
    margin-left: auto;
  
    margin-right: auto;

}
.bg-white.ss {
  border-radius: 10px;
  height: 122px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
margin-left: 53px;
    margin-top: -48px;
}
.img-profile {
  display: block;
  margin-left: 9;
  margin-right: 9;
  margin-top: 21px;
  padding-right: 12px;
  width: 109px;
  height: 87px;
  float: left;
}
.name-status {
  font-family: “Times New Roman”, Times, serif;
  color: #7bc79a;

  font-size: 23.3px;
  font-weight: bold;
}
.name-now {
  font-family: “Times New Roman”, Times, serif;
  color: #585858cb;
  margin-top: 13px;
  font-size: 9px;
  font-weight: bold;
  padding: 2px 2px 2px 23px;
}
.name-price {
font-family: 'Bold 700', sans-serif;
  color: #000000;
  margin-top: 3px;
  font-size: 15px;
  padding: 7px 5px 3px 6px;
}
.name-time {
  font-family: “Lucida Console”, Monaco, monospace;
  color: #585858cb;
  margin-top: 32px;
  margin-bottom: 0px;
  font-size: 14px;
}
.pon {
  display: block;

  margin-right: 2px;
  margin-top: 8px;
  width: 33px;
  height: 33px;
  float: left;
}
.pon-t {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
</style>

